<template>
    <div class="star-rating">
        <img class="w-6 mx-1" v-for="n in 5" :key="n" :src="require(`../../assets/img/${n <= score ? 'full-star.png' : 'star-empty.png'}`)" />
    </div>
</template>

<script>
export default {
    name: 'StarRating',
    props: {
        score: {
            type: Number,
            required: true,
            validator: function (value) {
                return value >= 0 && value <= 5;
            },
        },
    },
};
</script>

<style scoped>
.star-rating {
    font-size: 2em;
}

.star {
    color: #ccc;
}

.painted {
    color: #fde16d;
}
</style>
